/* global Promise */
( function( $ ) {
	var facilitiesWrapEle, formsEles;
	var currRequest = null;
	const controller = new AbortController();

	document.addEventListener( 'DOMContentLoaded', function() {
		facilitiesWrapEle = document.querySelector( '.facility-tabs__container' );
		if( !facilitiesWrapEle ) { return; }

		formsEles = facilitiesWrapEle.querySelectorAll( 'form' );

		// Do this before everything's listening
		applyUrlFilters();
		
		facilitiesWrapEle.addEventListener( 'change', function( e ) {
			if( e.target.matches( 'input, select' ) ) {
				if( e.target.parentElement.matches( '.facility-filters__sort-zip, .facility-filters__single-search' ) ) { return; }
				makeNewRequest.apply( e.target );
			}
		} );

		facilitiesWrapEle.addEventListener( 'click', function( e ) {
			if ( e.target.matches( '.pagination__prev a:not([tabindex="-1"]), .pagination__next a:not([tabindex="-1"])' ) ) {
				pageNav( e );
			} 
		} );
		
		// Add analytics events to clicks on the results in the rehab tab (assuming that's the first one)
		if( window.dataLayer ) {
			let panelContainer = facilitiesWrapEle.querySelector( '.facility-tabs__panel .facility-result__container' );

			panelContainer.addEventListener( 'click', function( e ) {
				if( e.target.matches( '.facility-result a:not([data-toggle="tooltip"])' ) ) {
					var result = this.closest( '.facility-result' );
					var resultSetWrap = this.closest( '.facility-result__wrap' );
					var eventType = '';
					var url = this.getAttribute( 'href' ).toLowerCase(); // what's actually populated in the attribute, not the resolved url (keep it relative)
					
					if( url.match( /https?:\/\// ) ) {
						eventType = 'facility_web_click';
					} else if( this.classList.contains( 'facility-result__contact--phone' ) ) {
						eventType = 'facility_tel_click';
					} else {
						eventType = 'facility_profile_click';
					}
	
					var pageNum = parseInt( resultSetWrap.querySelector( '.pagination__pages input:checked' ).value );
					if( isNaN( pageNum ) ) { pageNum = 1; } // if there is no pagination, fall back to page 1
	
					var dataObj = {
						'event': eventType,
						'sponsored': result.classList.contains( 'facility-result--sponsored' ),
						'page': pageNum,
						'facility_id': result.dataset.facilityid,
						'facility': ( result.querySelector( '.facility-result__title' ).textContent ).trim(),
						'city': resultSetWrap.dataset.city || null,
						'state': resultSetWrap.dataset.state || null
					};
	
					window.dataLayer.push( dataObj );
				}
			} );
		}

		formsEles.forEach( form => {
			form.addEventListener( 'reset', function() {
				setTimeout( function() { // wait a beat for the inputs to update
					// uncheck anything remaining
					form.querySelectorAll( 'input[type="checkbox"]:checked' ).forEach( function( input ) {
						input.checked = false;
					} );

					// refresh the results
					makeNewRequest.apply( form );
				}, 1 );
			} );

			form.addEventListener( 'submit', function( e ) { e.preventDefault(); } );

			updateActiveFilters( form );
		} );
	} );

	// https://stackoverflow.com/a/9310752/738394
	function escapeRegExp( text ) {
		return text.replace( /[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&' );
	}

	function applyUrlFilters() {
		// Apply filters based on what's in the URL (assumed structure: [name]=[value]|[name]=[value])
		const h = window.location.hash;
		if( !h || !h.length ) { return; }

		// chop off the # and separate out the values
		const inputVals = h.substring( 1 ).split( '|' );

		// facilities-tabs has already activated the correct tab, assume there is only one
		var whichForm = Array.from( formsEles ).find( form => form.offsetWidth > 0 && form.offsetHeight > 0 ); // Checking only offset since no other styles are applied (like opacity)
		var inputEles = whichForm.querySelectorAll( 'input, select, textarea' );
		var updated = false;

		inputVals.forEach( function( attrs ) {
			attrs = attrs.split( '=' );
			
			// Case insensitive filters
			const nameSelector = function( ele ) {
				var name = ele.getAttribute( 'name' );
				return name && ( new RegExp( escapeRegExp( attrs[0] ), 'i' ) ).test( name );
			};
			const valSelector = function( ele ) {
				var val = ele.getAttribute( 'value' );
				return val && ( new RegExp( escapeRegExp( attrs[1] ), 'i' ) ).test( val );
			};

			var matches = Array.from( inputEles ).filter( nameSelector );

			matches.forEach( function( match ) {
				var t = match;

				if( t.type === 'checkbox' && valSelector( t ) ) {
					t.checked = true;
					updated = true;
				} else if( t.type === 'radio' && valSelector( t ) ) {
					// Uncheck the other radios in the group
					Array.from ( inputEles ).filter( input => nameSelector( input ) && !valSelector( input ) ).forEach( input => {
						input.checked = false;
					} );
					t.checked = true;
					updated = true;
				} else if( t.type !== 'checkbox' &&  t.type !== 'radio' ) {
					if( t.tagName.toLowerCase() === 'select' ) {
						// Find the correct case of the value and set the select to it
						var val = Array.from( t.querySelectorAll( 'option' ) ).find( valSelector ).value;
						if( val ) {
							t.value = val;
							updated = true;
						}
					} else {
						t.value = attrs[1];
						updated = true;
					}
				}
			} );
		} );

		if( updated ) {
			makeNewRequest.apply( whichForm, [true] );
		}
	}

	function pageNav( e ) {
		e.preventDefault();
		var pagination = e.target.closest( '.pagination' );
		var pages = pagination.querySelectorAll( 'input[type="radio"]' );
		var currPage = Array.from( pages ).find( input => input.checked );
		var currPageIndex = Array.from( pages ).indexOf( currPage );

		if( pagination.querySelector( '.pagination__prev a' ) === e.target ) {
			// go backwards
			if( currPageIndex > 0 ) {
				currPage.checked = false;
				let page = pages[ currPageIndex - 1 ];
				page.checked = true;
				page.dispatchEvent( new Event( 'change', { bubbles: true } ) );
			}
		} else {
			// go forwards
			if( currPageIndex < pages.length - 1 ) {
				currPage.checked = false;
				let page = pages[ currPageIndex + 1 ];
				page.checked = true;
				page.dispatchEvent( new Event( 'change', { bubbles: true } ) );
			}
		}
	}

	function updateActiveFilters( formEle ) {
		var formActiveContainers = formEle.querySelectorAll( '.facility-filters__active-wrap' );

		var checked = formEle.querySelectorAll( 'input[type="checkbox"]:checked' );

		if( checked.length === 0 ) {
			formActiveContainers.forEach( element => {
				while( element.firstChild ) {
					element.removeChild( element.firstChild );
				}

				element.closest( '.facility-filters__active' ).classList.remove( 'facility-filters__active--active' );
			} );
		} else {
			formActiveContainers.forEach( function( container ) {
				container.querySelectorAll( 'label' ).forEach( function( label ) { // remove all filters that are no longer checked
					var checkboxId = label.getAttribute( 'for' );
					if( Array.from( checked ).filter( checkbox => checkbox.id === ( checkboxId ) ).length == 0 ) {
						container.removeChild( label );
					}
				} );
			} );
			checked.forEach( function( input ) { // ensure all that are checked are in the active area
				var checkboxId = input.id;
				var nextSibling = input.nextElementSibling;
				var checkboxText = nextSibling.tagName.toLowerCase() === 'label' ? nextSibling.textContent.trim() : '';
				formActiveContainers.forEach( function( container ) {
					if( !container.querySelectorAll( '[for="' + checkboxId + '"]' ).length ) {
						var label = document.createElement( 'label' );
						label.setAttribute( 'for', checkboxId );
						label.classList.add( 'facility-filters__active-toggle' );
						label.textContent = checkboxText;
						container.appendChild( label );
					}
				} );
			} );
			
			formActiveContainers.forEach( function( container ) {
				container.closest( '.facility-filters__active' ).classList.add( 'facility-filters__active--active' );
			} );
		}
	}

	function makeNewRequest( preventScroll ) {
		var formEle = this.closest( 'form' );
		var zipInputEle = document.querySelector( '.facility-filters__sort-zip input' );
		var resultsSet = formEle.querySelector( '.facility-result__set' );
		
		updateActiveFilters( formEle );

		if( zipInputEle ) {
			zipInputEle.disabled = true;
		}

		const data = new FormData( formEle );


		formEle.querySelector( '.spinner' ).classList.add( 'spinner--active' );
		
		resultsSet.textContent = '';

		hideError.apply( formEle );
		
		if( !preventScroll ) {
			const containerEle = formEle.querySelector( '.facility-result__container' );

			containerEle.scrollIntoView( {
				behavior: 'smooth',
				block: 'start'
			} );

			containerEle.focus( {
				preventScroll: false
			} );
		}

		if( currRequest ) { controller.abort(); }
		
		var METHOD = formEle.getAttribute( 'method' );
		
		var requestOptions = {
			method: METHOD,
			headers: {
				'Content-Type': 'text/html; charset=utf-8'
			}
		};

		var fetchLink = formEle.getAttribute( 'action' );

		if( METHOD.toLowerCase() === 'get' ) {
			fetchLink += ( fetchLink.includes( '?' ) ? '&' : '?' ) + new URLSearchParams( data ).toString();
		} else {
			requestOptions.body = JSON.stringify( data );
		}

		currRequest = fetch( fetchLink, requestOptions )
			.then( ( response, rejectResponse ) => {
				if( !response.ok ) {
					return Promise.reject( rejectResponse );
				}
				return response.text();
			} )
			.then( response => {
				if ( response.length ) {
					renderResults.apply( formEle, [response] );
				} else {
					showErrorState.apply( formEle );
				}
			} )
			.catch( showErrorState ) 
			.finally( () => {
				formEle.querySelector( '.spinner' ).classList.remove( 'spinner--active' );
				currRequest = null;
				if( zipInputEle ) {
					zipInputEle.disabled = false;
				}
			} );
	}

	function renderResults( resultsEle ) {
		const parser = new DOMParser();
		const doc = parser.parseFromString( resultsEle, 'text/html' );
		var results = doc.body.firstChild; // The new facility-result__set

		var start = results.dataset.resultsStart;
		var end = results.dataset.resultsEnd;
		var total = results.dataset.resultsTotal;

		var countText = this.querySelector( '.facility-result__count' );
		countText.querySelector( '.facility-result__start' ).textContent = start;
		countText.querySelector( '.facility-result__end' ).textContent = end;
		countText.querySelector( '.facility-result__total' ).textContent = total;

		if( results.querySelectorAll( 'ul > li' ).length ) { // has results (organic or sponsored)
			this.querySelector( '.facility-result__set' ).replaceWith( results );
			$( this.querySelector( '[data-toggle="tooltip"]' ) ).tooltip(); // Maintaining JQuery due to bootstrap usage

			if( total ) { // has organic results
				hideError.apply( this );
				countText.style.display = 'block';
			} else { // no organic results
				showErrorState.apply( this );
			}

			document.body.dispatchEvent( new Event( 'facility-result-rendered', { bubbles: true } ) );
		} else {
			var resultSet = this.querySelector( '.facility-result__set' );
			
			while( resultSet.firstChild ) {
				resultSet.removeChild( resultSet.firstChild );
			}

			showErrorState.apply( this );
		}
	}

	function showErrorState( error ) {
		facilitiesWrapEle.querySelector( '.facility-result__count' ).display = 'none';
		facilitiesWrapEle.querySelector( '.facility-result__container' ).classList.add( 'facility-result--error' );
		
		// eslint-disable-next-line no-console
		console.error( 'Error: ', error );
	}

	function hideError() {
		facilitiesWrapEle.querySelector( '.facility-result__container' ).classList.remove( 'facility-result--error' );
	}


} )( jQuery );